var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{attrs:{"text":"","color":"success"}},[_vm._v(" All done, now wait until shipment is delivered! ")])}
var staticRenderFns = []

export { render, staticRenderFns }